// extracted by mini-css-extract-plugin
export default {"controlGroup":"Fullscreen_controlGroup__sxNIS","controlContainer":"Fullscreen_controlContainer__H5h7B"};